import { alpha, darken } from "@commonlibs";
import { css } from "styled-components";

export const ScrollBarStyles = css(
    ({ theme }) => css`
        /* width */
        body::-webkit-scrollbar {
            display: none;
        }
        body {
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
        ::-webkit-scrollbar {
            width: 0.375rem;
            height: 0.375rem;
            cursor: pointer;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            border-radius: 100px;
            background: ${alpha(theme.palette.gray[800], 0.2)};
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background-color: ${theme.palette.primary};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background-color: ${darken(theme.palette.primary, 0.1)};
        }
    `,
);
